import { styled } from '@material-ui/core/styles';
import { down } from 'utils/breakpointHelpers';

export const DeliveryDatesContainer = styled('div')({
  minWidth: '180px',
  [down('sm')]: {
    width: '100%',
  },
});
